/* Native product media entry. No model or player is instantiated until requested. */
if (!customElements.get('product-model-entry')) {
  class ProductModelEntry extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('dialog');
      this.stage = this.querySelector('[data-model-stage]');
      this.status = this.querySelector('[data-model-status]');
      this.retry = this.querySelector('[data-model-retry]');
      this.opener = this.querySelector('[data-model-open]');
      this.templates = Array.from(this.querySelectorAll('template[data-model-template]'));
      this.selector = this.querySelector('[data-model-select]');
      this.opener.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-model-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.selector?.addEventListener('change', () => this.showModel(this.selector.value), options);
      this.retry.addEventListener('click', () => this.showModel(this.modelId, true), options);
      // Concept replaces the gallery contents after a variant selection. The entry
      // stays outside that replacement, with every product model still available.
      this.form = document.forms[this.dataset.formId];
      this.form?.addEventListener('variant:change', () => this.selectPreferredModel(), options);
      this.selectPreferredModel();
    }

    disconnectedCallback() {
      this.dialog?.close();
      this.close();
      this.events?.abort();
      this.events = null;
    }

    selectPreferredModel() {
      const gallery = document.getElementById(this.dataset.galleryId);
      const visible = Array.from(gallery?.querySelectorAll('[data-media-type="model"]') || [])
        .find((media) => !media.hidden && !media.closest('[hidden]'));
      const preferred = this.templates.find((item) => item.dataset.modelTemplate === visible?.dataset.mediaId) || this.templates[0];
      if (!preferred) return;
      this.querySelector('[data-model-caption]').textContent = preferred.dataset.modelCaption;
      if (!this.dialog.open) {
        this.modelId = preferred.dataset.modelTemplate;
        if (this.selector) this.selector.value = this.modelId;
      }
    }

    open() {
      this.returnFocus = document.activeElement;
      this.dialog.showModal();
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      this.showModel(this.modelId);
    }

    close() {
      this.requestId = (this.requestId || 0) + 1;
      this.activeMedia?.pause();
      if (this.locked) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }
    }

    async showModel(id, retry = false) {
      const template = this.templates.find((item) => item.dataset.modelTemplate === id);
      if (!template) return;
      const request = this.requestId = (this.requestId || 0) + 1;
      this.activeMedia?.pause();
      // Pause the gallery's existing model if the shopper has already opened it.
      document.getElementById(this.dataset.galleryId)?.querySelectorAll('model-media').forEach((media) => media.pause?.());
      if (this.stage.dataset.modelId !== id || retry) {
        this.stage.replaceChildren(template.content.cloneNode(true));
        this.stage.dataset.modelId = id;
        this.activeMedia = this.stage.querySelector('model-media');
        // This standalone preview must not alter the gallery slider or variant.
        this.activeMedia.removeAttribute('aria-controls');
        this.activeMedia.setAttribute('data-model-interactive-preview', '');
        this.activeMedia.querySelectorAll('[id]').forEach((element) => { element.id += '-entry'; });
      }
      this.modelId = id;
      this.querySelector('[data-model-caption]').textContent = template.dataset.modelCaption;
      this.querySelector('[data-model-title]')?.replaceChildren(template.dataset.modelCaption);
      this.status.textContent = 'Loading 3D preview…';
      this.retry.hidden = true;
      try {
        await customElements.whenDefined('model-media');
        if (request !== this.requestId || !this.dialog.open) return;
        await this.activeMedia.loadAndPlay();
        if (request !== this.requestId || !this.dialog.open) return;
        this.status.textContent = 'Drag to rotate. Scroll or pinch to zoom.';
      } catch (error) {
        if (request !== this.requestId || !this.dialog.open) return;
        this.status.textContent = 'The 3D preview could not load. Please try again.';
        this.retry.hidden = false;
      }
    }
  }
  customElements.define('product-model-entry', ProductModelEntry);
}
